const firebaseConfig = {
  apiKey: "AIzaSyBdha7pD_2klOnFOdqonKuSRmDzzCIoVGY",
  authDomain: "agrify-app.firebaseapp.com",
  projectId: "agrify-app",
  storageBucket: "agrify-app.appspot.com",
  messagingSenderId: "9316707536",
  appId: "1:9316707536:web:58574810cc806cdbbc42d5",
  measurementId: "G-4ZRGFDQPST",
};

export default firebaseConfig;
